export default __webpack_public_path__ + "static/media/crc.7e1b6bc4.svg";